import { Box } from '@mui/material'
import AiAskBarAttachAction from './AiAskBarAttachAction'
import AiAskBarSpeakButton from './AiAskBarSpeakButton'
import { MAX_MESSAGE_ATTACHMENTS } from './aiAskBarLayoutConstants'
import styles from './index.module.scss'

/**
 * The composer while voice mode is live: a single 54px row holding attach and
 * Stop, nothing else.
 *
 * The editor, persona, model and dictation controls are all removed rather
 * than disabled — while the user is talking there is no text to style, no
 * second way to send, and a row of dimmed controls would only suggest the
 * composer is still listening to the keyboard.
 */
export default function AiAskBarLandingVoiceRow({ vm, actions, onVoiceToggle }) {
  return (
    <Box className={styles.voiceRow}>
      <AiAskBarAttachAction
        disabled={vm.attachments.length >= MAX_MESSAGE_ATTACHMENTS}
        onUpload={actions.handleOpenFilePicker}
        onSelectFromDocuments={actions.handleOpenDocumentsPicker}
      />
      <AiAskBarSpeakButton mode="stopVoice" onClick={onVoiceToggle} />
    </Box>
  )
}
